import * as React from "react";
const SvgWhiteDashIconsMinusLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#FFF", fillRule: "evenodd", d: "M4 12.5h16v-1H4z" }));
export default SvgWhiteDashIconsMinusLine;
